var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#020002"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.5C14.3201 9.5 13.6555 9.70161 13.0902 10.0793C12.5249 10.457 12.0843 10.9939 11.8242 11.622C11.564 12.2501 11.4959 12.9413 11.6286 13.6081C11.7612 14.2749 12.0886 14.8874 12.5693 15.3682C13.0501 15.8489 13.6626 16.1763 14.3294 16.3089C14.9962 16.4416 15.6874 16.3735 16.3155 16.1133C16.9436 15.8532 17.4805 15.4126 17.8582 14.8473C18.2359 14.282 18.4375 13.6174 18.4375 12.9375C18.4375 12.0258 18.0753 11.1515 17.4307 10.5068C16.786 9.86216 15.9117 9.5 15 9.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.375C13.0964 5.375 11.2355 5.9395 9.65264 6.99711C8.06982 8.05471 6.83616 9.55793 6.10766 11.3167C5.37917 13.0754 5.18856 15.0107 5.55995 16.8777C5.93133 18.7448 6.84802 20.4598 8.1941 21.8059C9.54018 23.152 11.2552 24.0687 13.1223 24.4401C14.9893 24.8114 16.9246 24.6208 18.6833 23.8923C20.4421 23.1638 21.9453 21.9302 23.0029 20.3474C24.0605 18.7645 24.625 16.9036 24.625 15C24.6221 12.4482 23.6071 10.0017 21.8027 8.19727C19.9983 6.39286 17.5518 5.37788 15 5.375ZM20.4948 21.1365C20.4812 20.2347 20.1137 19.3743 19.4717 18.7408C18.8297 18.1074 17.9644 17.7515 17.0625 17.75H12.9375C12.0356 17.7515 11.1704 18.1074 10.5283 18.7408C9.88628 19.3743 9.51883 20.2347 9.50516 21.1365C8.25842 20.0233 7.37923 18.5576 6.98398 16.9336C6.58874 15.3096 6.6961 13.6038 7.29185 12.0421C7.88759 10.4805 8.94362 9.13663 10.3201 8.1885C11.6966 7.24037 13.3286 6.73269 15 6.73269C16.6714 6.73269 18.3034 7.24037 19.6799 8.1885C21.0564 9.13663 22.1124 10.4805 22.7082 12.0421C23.3039 13.6038 23.4113 15.3096 23.016 16.9336C22.6208 18.5576 21.7416 20.0233 20.4948 21.1365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.c355f9575404690cc3f32e5aabe5eaae.svg";
export { ForwardRef as ReactComponent };